var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTarget = function SvgTarget(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#10131A",
    fillRule: "evenodd",
    d: "M4.285 11.734c0 5.316 6.455 7.986 10.212 4.23a5.985 5.985 0 0 0 .863-7.371l-2.147 2.147c.678 2.003-.81 4.104-2.946 4.104-2.755 0-4.158-3.347-2.197-5.308l-.002-.001a3.11 3.11 0 0 1 3.194-.748l2.146-2.146c-3.953-2.442-9.123.395-9.123 5.093m14.713-6.665-1.106.017-6.014 6.013c.677 1.74-1.516 3.175-2.834 1.858a1.734 1.734 0 0 1-.002-2.449l.002.002a1.73 1.73 0 0 1 1.856-.386l6.014-6.014.017-1.107a.84.84 0 0 1 .255-.601L19.523.064a.217.217 0 0 1 .371.158l-.03 1.914 1.915-.03a.217.217 0 0 1 .157.37l-2.338 2.339a.83.83 0 0 1-.6.254M0 11.734a10.269 10.269 0 0 1 16.235-8.355l-.006.441-1.824 1.824c-4.844-3.3-11.5.161-11.5 6.09a7.36 7.36 0 0 0 7.362 7.362c5.93 0 9.39-6.657 6.091-11.5l1.824-1.824.442-.007a10.24 10.24 0 0 1 1.911 5.968C20.535 17.403 15.94 22 10.268 22S0 17.404 0 11.734",
    clipRule: "evenodd"
  })));
};
export default SvgTarget;